import { ReactNode } from "react";
import { useKeycloak } from "@react-keycloak/web";

import { Loading } from "@components";

import { PermissionType } from "./Routes/types";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

const tokenAuthNeeded = (authPermission: string[]): boolean =>
  authPermission.includes("token");

const AllowedComponent = (
  element?: ReactNode,
  redirection?: ReactNode,
  permissions?: PermissionType,
): ReactNode => {
  const { user } = useUser();

  const { realm_roles: roles } = user || {};

  const { keycloak } = useKeycloak();

  const hasAccess =
    permissions && permissions.access && getAccess(roles, permissions.access);

  if (permissions) {
    if (tokenAuthNeeded(permissions.auth)) {
      if (keycloak.token) {
        if (permissions.access) {
          if (hasAccess) {
            return element;
          } else return redirection;
        } else return element;
      } else return <Loading />;
    } else return element;
  } else return element;
};

export { AllowedComponent };
